import React from 'react';
import Image from 'next/image';
import { FaHeadphones, FaPhoneAlt } from 'react-icons/fa';
import Link from 'next/link'
const Engagement2 = ({ props }: any) => {
    return (
        <div className='w-full py-12 px-4'>
            <div className='w-full lg:w-[95%] 2xl:w-[77%] flex flex-col lg:flex-row justify-around items-center mx-auto gap-8'>
                <Image
                    src={'/awards/award-engage.svg'}
                    alt='Award'
                    width={447}
                    height={300}
                    className='w-full max-w-[447px] h-auto'
                />
                <div className='w-full lg:w-1/2 text-center lg:text-left'>
                    <div className='text-[28px] sm:text-[32px] md:text-[38px] font-semibold text-homeblack'>
                        {props?.title}
                    </div>
                    <div className='text-homegrey mt-4' dangerouslySetInnerHTML={{ __html: props?.description }} />
                    {/* {props?.description}                    </div> */}
                    <div className='text-blue text-[22px] sm:text-[26px] md:text-[28px] font-semibold mt-4'>
                        {props?.subtitle}
                    </div>
                    <div className="mt-5 flex flex-col sm:flex-row justify-center lg:justify-start gap-5">
                        {(props.text1 || props?.link_text1) && (props.link1 || props?.link_url1) && (
                            <Link href={`${props.link1|| props?.link_url1}`}>
                            <div className="bg-pink flex items-center justify-center hover:bg-white duration-300 hover:text-pink border-2 hover:border-pink border-white gap-2 px-4 rounded-xl text-white py-2 text-[18px] sm:text-[20px] cursor-pointer">
                                <FaPhoneAlt className="w-5 h-5" />
                                {props.text1 || props?.link_text1}
                            </div >
                            </Link>
                        )}
                        {(props.text2 || props?.link_text2) && (props.link2 || props?.link_url2) && (
                            <Link href={`${props.link2 || props?.link_url2}`} >
                            <div  className="flex items-center justify-center text-pink border-2 duration-300 hover:bg-pink hover:text-white border-pink gap-2 px-4 rounded-xl py-2 text[18px] sm:text-[20px] cursor-pointer">
                                <FaHeadphones className="w-5 h-5" />
                                {props.text2 || props?.link_text2}
                            </div>
                             </Link>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Engagement2;
